<!-- 柱状图组件 -->
<template>
  <div class="bar_Echart">
    <div :id="barData.barId" :style="{ width: '100%', height: '100%' }"></div>
    <div :class="more ? 'more_unit' : 'unit'">
      {{ $t('Company') }}：
      <i class="unit_icon" :style="{ background: barData.picUnit ? barData.color[0] : barData.color }"></i>
      {{ barData.unit }}
      {{ barData.videoUnit ? barData.videoUnit : '' }}

      <i class="unit_icon" :style="{ background: barData.color[1], marginLeft: '5px' }" v-if="barData.picUnit"></i>
      {{ barData.picUnit ? barData.picUnit : '' }}
    </div>
    <div class="pagination" v-if="more">
      <span>{{ staticProport.currentPage }}/{{ staticProport.totalData }}</span>
      <el-pagination layout="prev,next" @current-change="handleTraceChange" :current-page="staticProport.currentPage"
        :page-size="staticProport.pageSize" :total="staticProport.totalUser">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { splitArray } from '@/util/common'
import { mapGetters } from 'vuex'
export default {
  props: {
    lineName: {
      type: String,
    },
    barName: {
      type: String,
    },
    barData: {
      type: [Array, Object],
    },
    more: {
      type: Boolean,
    },
  },
  data() {
    return {
      myChart: {},
      Xdata: [],
      Data: [],
      TwoData: [],
      staticProport: {
        totalUser: 0,
        currentPage: 1,
        totalData: 0,
        pageSize: 16,
        XuserData: [],
        onlineData: [],
        picData: [],
      },
      textColor: '',
      splitLineColor: '',
    }
  },
  methods: {
    // 轨迹切换分页
    handleTraceChange(val) {
      this.staticProport.currentPage = val
      this.Xdata = this.staticProport.XuserData[val - 1]
      this.Data = this.staticProport.onlineData[val - 1]
      if (this.barData.allAudioData) {
        this.TwoData = this.staticProport.picData[val - 1]
      }
      this.getHistogram()
    },
    // 做数据截取
    arrayChunk() {
      //机构活跃度
      let proportPage = Math.ceil(this.barData.allXData.length / 16)
      // 总页数
      this.staticProport.totalUser = this.barData.allXData.length
      this.staticProport.totalData = proportPage
      this.staticProport.XuserData = splitArray(this.barData.allXData, 16)
      this.staticProport.onlineData = splitArray(this.barData.allBarData, 16)
      if (this.barData.allAudioData) {
        this.staticProport.picData = splitArray(this.barData.allAudioData, 16)
        this.TwoData = this.staticProport.picData[0]
      }

      // 第一页数据
      this.Xdata = this.staticProport.XuserData[0]
      this.Data = this.staticProport.onlineData[0]
      this.getHistogram()
    },
    // 柱状图
    getHistogram() {
      if (this.isDefaultTheme) {
        this.textColor = '#333'
        this.splitLineColor = 'rgba(210, 210, 210, 0.5)'
      } else {
        this.textColor = '#fff'
        this.splitLineColor = 'rgba(101, 198, 231, 0.2)'
      }
      this.$nextTick(() => {
        if (!this.more) {
          this.Xdata = this.barData.xData
          this.Data = this.barData.barEchartData
          this.TwoData = this.barData.barAudioData
        }
        let minInter = Math.min.apply(null, this.Data) // 最小值
        let MAXInter = Math.max.apply(null, this.Data) // 最大值
        let splatInter
        if (MAXInter - minInter > 0) {
          splatInter = Math.ceil((MAXInter - minInter) / 2)
        } else {
          splatInter = 2
        }
        this.myChart = this.$echarts.init(document.getElementById(this.barData.barId))
        this.myChart.setOption({
          tooltip: {
            transitionDuration: 0, //加上这个可以防止抖动
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
          },
          color: this.barData.color,
          // legend: {
          //   bottom: '1%',
          //   left: 'right',
          //   textStyle: {
          //     color: this.barData.color,
          //   },
          // },
          xAxis: {
            type: 'category',
            data: this.Xdata,
            axisLabel: {
              textStyle: {
                color: this.textColor,
              },
              // x轴格式化，文字过多时x轴仅显示前5个字
              formatter: function (params) {
                var newParamsName = '' // 最终拼接成的字符串
                var paramsNameNumber = params.length // 实际标签的个数
                var provideNumber = 4 // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
                var language = localStorage.getItem('lang')
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (language === 'en') {
                  newParamsName = params
                } else {
                  if (paramsNameNumber > provideNumber) {
                    /** 循环每一行,p表示行 */
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = '' // 表示每一次截取的字符串
                      var start = p * provideNumber // 开始截取的位置
                      var end = start + provideNumber
                      // 此处特殊处理最后一行的索引值
                      if (p == rowNumber - 1) {
                        // 最后一次不换行
                        tempStr = params.substring(start, paramsNameNumber)
                      } else {
                        // 每一次拼接字符串并换行
                        tempStr = params.substring(start, end) + '\n'
                      }
                      newParamsName += tempStr // 最终拼成的字符串
                    }
                  } else {
                    // 将旧标签的值赋给新标签
                    newParamsName = params
                  }
                }
                //将最终的字符串返回
                return newParamsName
              },
            },
            axisLine: {
              lineStyle: {
                color: this.splitLineColor, //更改坐标轴颜色
              },
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            type: 'value',
            minInterval: splatInter,
            axisLabel: {
              textStyle: {
                color: this.textColor,
              },
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.splitLineColor,
              },
            },
            axisLine: {
              show: false,
            },
          },
          grid: {
            x: '3%', //距离左边
            x2: '2%', //距离右边
            y: '10%', // 上距离
            y2: '8%', // 下距离
            containLabel: true,
          },
          series: [
            {
              name: this.barData.lineName,
              data: this.Data,
              type: 'bar',
              barWidth: 10, //柱图宽度
            },
            {
              name: this.barData.barName,
              data: this.TwoData,
              type: 'bar',
              barWidth: 10, //柱图宽度
            },
          ],
        })
      })
    },
  },
  mounted() {
    this.getHistogram()
  },
  watch: {
    isDefaultTheme: {
      immediate: true,
      handler() {
        this.getHistogram()
      },
    },
    'barData.xData': function () {
      this.getHistogram()
    },
    barData: {
      handler() {
        this.arrayChunk()
      },
      deep: true,
    },
    more: {
      immediate: true,
      handler() {
        if (this.more) {
          this.arrayChunk()
        }
      },
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.bar_Echart
  width: 100%
  height: 100%
  min-height 100px;/*no*/
  position: relative
  .pagination
    position absolute
    top 2%
    right 10%
    display flex
    span
      height: 30px;/*no*/
      line-height: 30px;/*no*/
      color #333
  .unit_icon
    width: 10px
    height: 10px
    border-radius: 50%
    display: inline-block
    margin-right 5px
>>>.el-pagination button:disabled, >>>.el-pagination .btn-next, >>>.el-pagination .btn-prev
  background var(--table-pagination-bg-color)
// 深色样式
.theme-dark
  .bar_Echart
    span
      color #fff
</style>
